import { useEffect, useState } from 'react';
import style from './guess.module.scss';

export default function Guess({ isGuessed, guess, word, isShaking, wordLengths, count }, ref) {

    const [isVisible, setIsVisible] = useState([])
    

    const getLetterStatus = (charL, index) => {
        if (!isGuessed) return style.BlackColor;
        if (charL === word[index]) return style.GreenColor;
        if (word.includes(charL)) return style.YellowColor;
        return style.BlackColor;
    };

    const getLayoutInfo = () => {
        let numBoxes = 5;  // Use let so you can reassign
        let containerClass = style.GuessContainer; // Same here
        
        if (count === 3) {
            numBoxes = wordLengths;  // Update based on the count condition
            containerClass = style.GuessContainer2;  // Update container class
        }
        
        return { numBoxes, containerClass };
    };
    
    const { numBoxes, containerClass } = getLayoutInfo();


    useEffect(() => {
        setIsVisible([]);
        console.log(count);
        if (count === 3) {
            const timeoutIds = [];
    
            for (let i = 0; i < numBoxes; i++) {
                const timeoutId = setTimeout(() => {
                    setIsVisible((prev) => [...prev, i]);
                }, i * 100);
                timeoutIds.push(timeoutId);
            }
    
            return () => timeoutIds.forEach(id => clearTimeout(id));
        } else {
            setIsVisible([...Array(numBoxes).keys()]);
        }
       

    }, [numBoxes, count])

    return (
        <div className={`${containerClass} ${isShaking ? style.Shaking : ''}`}>
            {new Array(numBoxes).fill(0).map((_, i) => (
                <div 
                    key={i} 
                    className={`${style.GuessBoxes} ${getLetterStatus(guess[i] || '', i)} ${guess[i] ? style.edited : ''}`}
                    ref={i === 0 ? ref : null} // Attach ref only to first box
                    tabIndex={0} // Allows focusing
                    style={{
                        opacity: isVisible.includes(i) ? 1 : 0,
                        transition: 'opacity 0.3s ease-in-out',
                    }}
                >
                    {guess[i] || ''}
                </div>
            ))}
        </div>
    );
}